module.exports = __webpack_public_path__ + "static/media/Weather.6dfbe73e.png";